import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useBlockPartner() {
  const { t } = useTranslation(['partners', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { patcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const blockPartner = async (partnerId: number) => {
    setLoading(true)
    setError(null)
    setSuccess(null)
    try {
      await patcher<void>(
        `${CONFIG.BOUNCE_API}/api/v1/partners/${partnerId}/block`
      )
      setSuccess(t('partners:partners.hook.successfully-blocked'))
      return true
    } catch (caughtError) {
      setError(
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      )
      return false
    } finally {
      setLoading(false)
    }
  }

  return { blockPartner, loading, error, success, resetState }
}
